import React, { FC, useMemo } from "react";

import { FeatureCard } from "./components/FeatureCard";
import { FeatureCardLoader } from "./components/FeatureCardLoader/FeatureCardLoader";
import { NoFeatureCard } from "./components/NoFeatureCard";

import { useFeatureCardModule } from "./hooks/useFeatureCardModule";
import { usePostgresLayer } from "../../hooks/layer/usePostgresLayer";
import { useTempLayer } from "../../hooks/layer/useTempLayer";
import { useSelectFeaturesLayerName } from "../../hooks/selectFeatures/useSelectFeaturesLayerName";
import { useFeatureToShow } from "../FeatureSelector/hooks/useFeatureToShow";

export const FeatureCardModule: FC = () => {
  const { feature, mode, loading } = useFeatureCardModule();
  const { layerName: layerToShow } = useFeatureToShow();
  const [selectFeaturesLayerName] = useSelectFeaturesLayerName();
  const layerName = useMemo(() => selectFeaturesLayerName || layerToShow, [layerToShow, selectFeaturesLayerName]);
  const { postgresLayer } = usePostgresLayer(layerName, { waitInput: true });
  const { getTempLayerInfo } = useTempLayer();
  const tempLayerInfo = getTempLayerInfo(layerName);
  const layerInfo = tempLayerInfo || postgresLayer;

  if (!layerName && !feature) {
    return loading ? <FeatureCardLoader /> : null;
  }

  if (selectFeaturesLayerName && !feature) {
    return <NoFeatureCard description={layerInfo?.alias || layerInfo?.name} />;
  }

  return <FeatureCard feature={feature} layerName={layerName} mode={mode} loading={loading} />;
};
